import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  btnwrapper: {
    width: "48px",
    height: "48px",
    minWidth: "48px",
    minHeight: "48px",
    borderRadius: "50%",
    padding: 0,
    borderWidth: "2px",
    borderColor: "inherit",
    borderStyle: "solid",
    "&.primaryOutlined": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: "transparent",
        color: theme.custom.linkHover.color,
        borderColor: theme.custom.linkHover.color,
      },
    },
    "&.primaryContained": {
      color: theme.custom.color.white,
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.custom.linkHover.color,
        borderColor: theme.custom.linkHover.color,
      },
    },
  },
}));
